import './_style.scss';

import React, { useState } from 'react';
import { toast } from 'react-toastify';
import { Button, Col, Input, Row } from 'reactstrap';

const PaginationControl = ({ itemsTotal, tableRef, sizePerPage }) => {

  const [pageNumber, setPageNumber] = useState();
  const pagesTotal = !!itemsTotal && !!sizePerPage ? Math.ceil(itemsTotal / sizePerPage) : 0;
  const minPage = 1;

  const paginationGoToPage = (e) => {
    e.preventDefault();
    if (pageNumber < minPage) {
      setPageNumber(minPage);
      return;
    }

    if (pageNumber > pagesTotal) {
      toast.error(`Página ${pageNumber} não existe na listagem. (Páginas: ${pagesTotal})`);
      setPageNumber("");
      return false
    }

    if (!!tableRef) tableRef.pagination.changePage(pageNumber);
  };

  if (itemsTotal <= sizePerPage) {
    return (<React.Fragment/>);
  }
  
  return (
    <Row className="d-flex flex-row-reverse">
      <Col sm={6}>
        <div className="custom-gotopage float-right">
          <form noValidate onSubmit={paginationGoToPage}>
            <Input
              type="number"
              name="page_number"
              maxLength="4"
              step="1"
              max={pagesTotal}
              min={minPage}
              onChange={(e) => setPageNumber(e.target.value)}
              value={pageNumber}
            />
            <Button
              type="submit"
              color="secondary"
              className="btn btn-success"
            >Vá para página</Button>
          </form>
        </div>
      </Col>
    </Row>
  );
}

export default PaginationControl;
